module.exports = __webpack_public_path__ + "img/b6-4.be464b9.svg";